import { default as broker1J3wPgxN67Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue?macro=true";
import { default as doplnenie_45udajovPG4ma8auXIMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue?macro=true";
import { default as doplnenieAmc5OUYgUnMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue?macro=true";
import { default as fotodokumentacia2tans5e3kHMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue?macro=true";
import { default as kalkulacieyIKt8EV7MqMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue?macro=true";
import { default as platbankriCWplm3Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue?macro=true";
import { default as ponukyEc9rR0D4xjMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue?macro=true";
import { default as rekapitulaciaOgtjxocDKlMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue?macro=true";
import { default as upsellFrcdm8rBRfMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue?macro=true";
import { default as vyrocie4SVnwPiIs2Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue?macro=true";
import { default as zavolajtemi8SERg8Kk29Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue?macro=true";
import { default as pageTTlDxtFlPhMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testvYtjFaSUtgMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagecxdHmU8u9tMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleO05q4uQoEvMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsBkaI7TAUPsMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagdeojX8FnTOMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorlOPVRQsHVFMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categorykbIYgvpmM9Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionGtWJ7rcH37Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articleszFX2IKFVS2Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryes3wE0DWbzMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleNYSfrkJvYCMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionUOvWZIGZzlMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as poistenie_45zivot_45uniqakiiD5sUDHYMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa?macro=true";
import { default as odhlasenie_45z_45mailinguiefhTNga29Meta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu?macro=true";
import { default as complaintbWifPQwB3qMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint?macro=true";
import { default as contact4UATShhzsjMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationl0XoYOm3fYMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as zadostaJS40NTX8sMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankMdtWwmgnVUMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnanigAfYZy06ndMeta } from "/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
export default [
  {
    name: "autopoistenie-broker",
    path: "/autopoistenie/broker",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue")
  },
  {
    name: "autopoistenie-doplnenie-udajov",
    path: "/autopoistenie/doplnenie-udajov",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue")
  },
  {
    name: "autopoistenie-doplnenie",
    path: "/autopoistenie/doplnenie",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue")
  },
  {
    name: "autopoistenie-fotodokumentacia",
    path: "/autopoistenie/fotodokumentacia",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue")
  },
  {
    name: "autopoistenie-kalkulacie",
    path: "/autopoistenie/kalkulacie",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue")
  },
  {
    name: "autopoistenie-platba",
    path: "/autopoistenie/platba",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue")
  },
  {
    name: "autopoistenie-ponuky",
    path: "/autopoistenie/ponuky",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue")
  },
  {
    name: "autopoistenie-rekapitulacia",
    path: "/autopoistenie/rekapitulacia",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue")
  },
  {
    name: "autopoistenie-upsell",
    path: "/autopoistenie/upsell",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue")
  },
  {
    name: "autopoistenie-vyrocie",
    path: "/autopoistenie/vyrocie",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue")
  },
  {
    name: "autopoistenie-zavolajtemi",
    path: "/autopoistenie/zavolajtemi",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue")
  },
  {
    name: pageTTlDxtFlPhMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testvYtjFaSUtgMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagecxdHmU8u9tMeta?.name,
    path: "/magazin",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleO05q4uQoEvMeta?.name,
    path: "/magazin/:article(.*)*",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsBkaI7TAUPsMeta?.name,
    path: "/magazin/vzory-dokumentov",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagdeojX8FnTOMeta?.name,
    path: "/magazin/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorlOPVRQsHVFMeta?.name,
    path: "/magazin/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categorykbIYgvpmM9Meta?.name,
    path: "/magazin/:category(poistenie|financie)",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionGtWJ7rcH37Meta?.name,
    path: "/magazin/:category(poistenie|financie)/:section(cestovanie|zivot|dom-a-domacnost|auto|pozicky-a-uvery)",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articleszFX2IKFVS2Meta?.name,
    path: "/magazin/all-articles",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageTTlDxtFlPhMeta?.name,
    path: "/slovnik-pojmov",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryes3wE0DWbzMeta?.name,
    path: "/slovnik-pojmov/:category(poistenie)",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleNYSfrkJvYCMeta?.name,
    path: "/slovnik-pojmov/:category(poistenie)/:id(.*)*",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionUOvWZIGZzlMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionUOvWZIGZzlMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: poistenie_45zivot_45uniqakiiD5sUDHYMeta?.name,
    path: "/poistenie-zivot-uniqa",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa")
  },
  {
    name: odhlasenie_45z_45mailinguiefhTNga29Meta?.name,
    path: "/odhlasenie-z-mailingu",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu")
  },
  {
    name: complaintbWifPQwB3qMeta?.name,
    path: "/reklamacie",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint")
  },
  {
    name: contact4UATShhzsjMeta?.name,
    path: "/kontakty",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationl0XoYOm3fYMeta?.name,
    path: "/poistenie/zmena-poistovne-autopoistenie",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: zadostaJS40NTX8sMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/zadost",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankMdtWwmgnVUMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnanigAfYZy06ndMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src4034395458/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  }
]